import {
  type InstallmentPaymentIneligibilityReason,
  installmentPaymentIneligibilityReasonSchema,
} from '@massilia/contracts'
import { AxiosError } from 'axios'
import { z } from 'zod'

/** Corps du 400 « éligibilité perdue » : tout autre corps repart en `null`. */
const ineligibilityBodySchema = z.object({
  reason: installmentPaymentIneligibilityReasonSchema,
})

/**
 * Extrait le motif de refus machine-lisible d'une erreur d'initiation de paiement 3/4x.
 *
 * Le serveur peut répondre 400 avec `{ reason: 'INSTALLMENT_ALREADY_USED' }` quand
 * l'éligibilité a changé entre l'affichage du formulaire et l'envoi. Le parsing est volontairement
 * défensif : n'importe quel autre corps de réponse (HTML d'un proxy, 500 sans body, message
 * texte…) doit simplement retourner `null` et laisser le message d'erreur générique parler.
 *
 * La reconnaissance des motifs est déléguée à `@massilia/contracts`, qui les déclare une
 * seule fois : recopier la liste ici la laisserait dériver en silence à chaque ajout.
 */
export function parseInstallmentIneligibilityReason(
  error: Error
): InstallmentPaymentIneligibilityReason | null {
  if (!(error instanceof AxiosError)) return null

  const body = ineligibilityBodySchema.safeParse(error.response?.data)
  return body.success ? body.data.reason : null
}
